import { ROUTE_PATHS } from 'utils/constant'
import { getGTM } from 'utils/functions'

export function LimitBlock() {
  return (
    <div className='mx-auto d-w-[829px] rounded-lg relative'>
      <img
        src='/images/top/limited-block/lead-desktop.webp'
        className='absolute left-0 d-top-[-16px] z-10 d-w-[298px] d-h-[40px]'
        alt='leading'
      />
      <div className='bg-white d-pt-[62px] d-pl-[60px] d-pb-[24px] d-pr-[48px] flex d-gap-[40px] rounded-tl-lg rounded-tr-lg relative z-0'>
        <div className='d-w-[337px] shrink-0'>
          <h3 className='d-text-[24px] d-leading-[30px] d-tracking-[2.4px] font-semibold'>
            Comadoの健康行動で
            <br />
            ポイントを貯めよう
          </h3>
          <div className='flex flex-col tracking-[0.04em] d-text-[18px] d-leading-[30px] font-medium d-mt-[16px]'>
            サントリーウエルネスの健康食品・美容商品や、サントリーグループの飲料・グッズの購入時に使えるポイントで、
            <br />
            1ポイント＝1円としてご利用できます。
          </div>
        </div>
        <div>
          <div className='flex items-center d-gap-[12px]'>
            <img
              src='/images/top/limited-block/product_01.webp'
              alt='product_01'
              className='d-h-[132px] object-contain'
            />
            <img
              src='/images/top/limited-block/product_02.webp'
              alt='product_02'
              className='d-h-[132px] object-contain'
            />
          </div>
          <p className='d-text-[12px] d-leading-[20px] d-mt-[18px] tracking-[0.1em]'>
            ※自販機でのお支払いは、対象自販機にて、全額ポイント支払いのみ対応となります。
            <br />
            ※ハーゲンダッツのギフト券は1枚でミニカップ・クリスピーサンド・バーのいずれか2個とお引き換え可能。
            <br />
            ※画像はイメージです。
          </p>
        </div>
      </div>
      <div className='bg-[#F4F5FB] d-py-[32px] d-px-[80px] d-text-[16px] d-leading-[30px] d-tracking-[1.6px] text-center font-medium rounded-br-lg rounded-bl-lg'>
        <p className='d-text-[16px] text-left font-medium'>
          ※Comadoの健康行動でポイントを貯める機能はオトク継続便の方限定機能です。
        </p>
        <p className='d-text-[16px] text-left font-medium d-mt-[4px]'>
          ※オトク継続便をご契約いただいていない方も、
          <br />
          初回ログインから30日間は期間限定でご利用いただけます。
        </p>
        <a
          {...getGTM({
            event_name: 'button_click',
            content_type: 'TOP_Point',
            content_id: 'ポイントとは',
          })}
          href={ROUTE_PATHS.POINT}
          className='font-semibold d-text-[18px] d-leading-[36px] d-tracking-[1.8px] items-center bg-primary-600 hover:bg-primary-700 hover:!shadow-none transform transition-all duration-150 hover:translate-y-[4px] rounded-full d-mt-[24px] inline-flex d-pl-[81px] d-py-[12px] d-pr-[18px] d-gap-[39px]'
          style={{
            boxShadow: 'rgb(215, 169, 5) 0px 4px 0px 0px',
          }}
        >
          <p className='font-semibold d-text-[18px] d-tracking-[1.8px]'>
            ポイントとは
          </p>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            className='transform -rotate-90 d-w-[20px] d-h-[20px]'
          >
            <path
              d='M10.9854 14.2973L16.8065 8.47626C17.594 7.68881 17.0363 6.34238 15.9226 6.34238L4.28049 6.34238C3.16686 6.34238 2.60915 7.68881 3.39661 8.47626L9.21768 14.2973C9.70584 14.7855 10.4973 14.7855 10.9854 14.2973Z'
              fill='currentColor'
            ></path>
          </svg>
        </a>
      </div>
    </div>
  )
}
